import React, { useEffect, useState } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IndoZambiaBankAnnounces2025FinancialPerformance = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Announces Strong 2025 Financial Performance Results</h1>

                    <p className="pb-3">Indo Zambia Bank yesterday announced its 2025 financial performance results at a Press Briefing following the 41st Annual General Meeting (AGM), highlighting a year of strong growth, resilience and strategic execution. Board Chairman Dr. Michael Gondwe emphasised that the Bank's performance reflects disciplined operations, prudent governance and a clear long-term vision.</p>

                    <p className="pb-3">Indo Zambia Bank recorded Profit Before Tax of K1.35 billion, up from K1.04 billion in 2024, while Profit After Tax rose to K932.8 million, with total comprehensive income at K1.13 billion. Total assets grew by 30% to K27.0 billion, driven by a strong expansion in the loan book to K10.19 billion, supporting key sectors of the economy. Customer deposits increased significantly to K21.47 billion, reflecting sustained trust, while the Bank maintained strong capital levels well above regulatory requirements. A dividend of K160 million was declared for the year ended 31st December 2025.</p>

                    <p className="pb-3">Also speaking at the Media Briefing, Managing Director Mr. Brajesh Kumar Singh highlighted the Bank's continued focus on supporting critical sectors such as agriculture, energy, manufacturing, mining and retail, while empowering women entrepreneurs, small-scale farmers, and key industry players. The Bank also advanced its digital transformation agenda, enhancing platforms such as the Indo NXT mobile application and upgrading core systems to deliver improved customer experience, security and accessibility.</p>

                    <p className="pb-3">Speaking at the event, Industrial Development Corporation Zambia (IDC) Chief Executive Mr. Cornwell Muleya commended the Bank's performance, stating: "The Bank's financial results are both impressive and instructive… These outcomes affirm the Bank's continued relevance as a key financial intermediary, effectively supporting economic activity through the provision of credit and financial services." He further noted that the dividend reflects a balanced approach to profitability, capital management, and shareholder value creation.</p>

                    <p className="pb-3">Looking ahead, Indo Zambia Bank remains committed to sustainable growth, innovation, and customer-centric service delivery, underpinned by strong risk management and governance. With a clear 2026–2031 strategic roadmap, the Bank is well-positioned to deepen its impact on Zambia's economic development while continuing to deliver value to its stakeholders under its brand promise: "Supporting you, Developing Zambia."</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #FinancialResults #Growth2025 #SustainableBanking #CustomerTrust #EconomicDevelopment</em></b></p>

                    <h2 className="pt-5 pb-4 text-left">Gallery</h2>
                    <Slider {...settings}>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1368.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1355.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1326.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1331.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1328.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1350.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1278.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                    </Slider>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default IndoZambiaBankAnnounces2025FinancialPerformance;
